import React, { useState, useEffect } from 'react';

function AuthForm({ debugLog }) {
  const [sessionToken, setSessionToken] = useState('');
  const [apiToken, setApiToken] = useState('');
  const [tokenStatus, setTokenStatus] = useState({ text: '', color: '' });

  useEffect(() => {
    loadTokensFromStorage();
  }, []);

  const loadTokensFromStorage = () => {
    const savedSessionToken = localStorage.getItem('zerodha_session_token');
    const savedApiToken = localStorage.getItem('api_token');
    
    if (savedSessionToken) setSessionToken(savedSessionToken);
    if (savedApiToken) setApiToken(savedApiToken);
    
    updateTokenStatus(savedSessionToken, savedApiToken);
    
    if (debugLog) debugLog('Loaded tokens from storage');
  };

  const saveTokens = () => {
    localStorage.setItem('zerodha_session_token', sessionToken);
    localStorage.setItem('api_token', apiToken);

    // If API token is provided, add it to the URL as a query parameter
    // This will refresh the page and set the cookie server-side
    if (apiToken) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('api_token', apiToken);
      window.location.href = currentUrl.toString();
    } else {
      updateTokenStatus(sessionToken, apiToken);
      showSuccess("Authentication tokens saved successfully!");
    }
    
    if (debugLog) debugLog('Saved tokens to storage');
  };

  const updateTokenStatus = (sessionToken, apiToken) => {
    const cookieApiToken = getCookie('api_token');

    if (sessionToken && (apiToken || cookieApiToken)) {
      setTokenStatus({
        text: "All tokens are saved. API token is " + 
          (cookieApiToken ? "set in cookie" : "saved in browser local storage"),
        color: "green"
      });
    } else {
      setTokenStatus({
        text: "Some tokens are missing",
        color: "red"
      });
    }
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const showSuccess = (message) => {
    // This would be handled by the parent component in a real implementation
    console.log(message);
  };

  return (
    <div className="auth-form">
      <h2>Authentication</h2>
      <div className="form-group">
        <label htmlFor="api-token">API Token:</label>
        <input 
          type="text" 
          id="api-token" 
          placeholder="Enter API Token"
          value={apiToken}
          onChange={(e) => setApiToken(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="session-token">Zerodha Session Token:</label>
        <input 
          type="text" 
          id="session-token" 
          placeholder="Enter Zerodha Session Token"
          value={sessionToken}
          onChange={(e) => setSessionToken(e.target.value)}
        />
      </div>
      <button onClick={saveTokens}>Save Tokens</button>
      <div className="token-status" style={{ color: tokenStatus.color }}>
        {tokenStatus.text}
      </div>
    </div>
  );
}

export default AuthForm;
